export class CommandsStore {
    commands: Array<string> = []
    commandCount = 0
    commandIndex = 0
    constructor() {
        this.commands = []
        this.commandCount = 0
        this.commandIndex = 0
        this.put = this.put.bind(this)
        this.prev = this.prev.bind(this)
        this.next = this.next.bind(this)
        this.resetIndex = this.resetIndex.bind(this)
        this.reset = this.reset.bind(this)
    }
    put(val: string) {
        this.commandCount++
        this.commandIndex = this.commandCount
        this.commands.push(val)
    }
    prev() {
        if (this.commandIndex > 0) {
            this.commandIndex--
        }
        return this.commands[this.commandIndex]
    }
    next() {
        if (this.commandIndex < this.commandCount - 1) {
            this.commandIndex++
            return this.commands[this.commandIndex]
        }
        this.commandIndex = this.commandCount
        return ''
    }
    resetIndex() {
        this.commandIndex = this.commandCount
    }
    reset() {
        this.commands = []
        this.commandCount = 0
        this.commandIndex = 0
    }
}
